import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CompanyPubrOperations, CompanyPubrSelectors } from '@panel/usuarios/src/store/ducks/myCompany';
import Cookies from 'js-cookie';
import { userInfoSelectors } from '../state/ducks/user';

const usePublisherUnifiedPanel = () => {
  const mockUnificated = {
    VAMX: '24MX',
    DVPE: 'UBPE'
  };
  const site = process.env.REACT_APP_BUILD_SITE;
  const dispatch = useDispatch();
  const [autologinState, setAutologinState] = useState(false);
  const { autologin, fetchedAutologin } = useSelector(CompanyPubrSelectors.getCompanyPubr);
  const { publisherId, userTypeId } = useSelector(userInfoSelectors.getuserInfoState);
  const isAdmin = userTypeId === '1';

  const getAutologin = useCallback(
    ({ modal = '' }) => {
      const publisher = publisherId && isAdmin ? { publisherId } : { publisherUserId: Cookies.get('usuarioFormId') };
      dispatch(
        CompanyPubrOperations.api({
          method: 'AUTOLOGIN',
          path: 'autologin',
          controller: 'portal',
          queryParams: publisher,
          headers: { 'x-panel-portal': mockUnificated[site] },
          general: true,
          modal
        })
      );
    },
    [dispatch, isAdmin, mockUnificated, publisherId, site]
  );

  useEffect(() => {
    if (fetchedAutologin && autologin) {
      setAutologinState(autologin);
    }
  }, [fetchedAutologin, autologin]);

  return { getAutologin, autologin: autologinState };
};

export { usePublisherUnifiedPanel };
